<template>
    <div class="delete-button-wrapper">
        <div ref="deleteButtonContainer" v-show="!showConfirmation">
            <button class="delete-btn-label btn btn-danger" :disabled="isDisabled" @click="handleDelete">{{ label }}</button>
        </div>
        <div ref="confirmationButtonContainer" class="confirmation-buttons" v-show="showConfirmation">
            <div class="d-flex">
                <a class="btn btn-danger w-50" href="#" @click="handleConfirmation"><span>&check;</span></a>
                <div class="btn btn-outline-danger w-50" @click="handleCancel"><i class="fa fa-times" aria-hidden="true"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";

export default {
    name: 'delete-button-with-confirmation',
    props: {
        label: {
            type: String,
            default: 'Delete'
        },
        isDisabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showConfirmation: false,
            transitionSpeed: 0.15,
        }
    },
    methods: {
        handleDelete() {
            this.toggleConfirmation();
            this.$emit("initial-click")
        },
        handleConfirmation() {
            this.$emit("delete");
            this.toggleConfirmation();
        },
        handleCancel() {
            this.$emit("cancelled");
            this.toggleConfirmation();
        },
        toggleConfirmation() {
            let tl = gsap.timeline();
            if (this.showConfirmation) {
                tl.to(this.$refs.confirmationButtonContainer,
                    {
                        duration: this.transitionSpeed,
                        ease: "ease.linear",
                        css: {opacity: 0},
                        onComplete: ()=>{
                            this.showConfirmation = false
                            }
                    });
                tl.to(this.$refs.deleteButtonContainer,
                    {
                        duration: this.transitionSpeed,
                        ease: "ease.linear",
                        css: {opacity: 1},
                    });
            } else {
                tl.to(this.$refs.deleteButtonContainer,
                    {
                        duration: this.transitionSpeed,
                        ease: "ease.linear",
                        css: {opacity: 0},
                        onComplete: ()=>{
                            let osh = this.$refs.deleteButtonContainer.offsetHeight;
                            let osw = this.$refs.deleteButtonContainer.offsetWidth;
                            this.$refs.confirmationButtonContainer.setAttribute("style","width:"+osw+"px; height:"+osh+"px; opacity: 0");
                            this.showConfirmation = true;
                            }
                    });
                tl.to(this.$refs.confirmationButtonContainer,
                    {
                        duration: this.transitionSpeed,
                        ease: "ease.linear",
                        css: {opacity: 1},
                    });
            }
        }
    }
}
</script>

<style>
.delete-btn-label {
    min-width: 125px;
}
</style>